<template lang="pug">
  div.skip
    div.skip-header
      img(src="/img/success.svg")
      h1 Благодарим за пользование<br>услугами АО «СТАТУС»!
    Box
      p {{ greetingText }} ожидаем вас для подачи документов {{ visitDate }} в {{ visitTime }} в офисе АО «СТАТУС» по адресу:
        = ' '
        a(:href="mapLink" class="map__link" target="_blank") {{ address }}
      .form__button
        Button(
          :action="toMain"
          :classes="['is-large']"
          label="Понятно"
        )
</template>

<script>
import Box from "@/components/ui/Box.vue";
import Button from "@/components/Button.vue";
import { dateToHuman } from "@/plugins/date-utils";
import { mapLink } from "@/plugins/ymap-utils";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "RepresentativeWithRecord",
  components: {
    Box,
    Button
  },
  computed: {
    ...mapGetters("form", ["forms"]),
    isLegalEntity() {
      return (
        this.forms.record &&
        this.forms.record.data.user_type_legal &&
        this.forms.record.data.user_type_legal.value
      );
    },
    greetingText() {
      if (this.isLegalEntity) {
        return "Уважаемый представитель юридического лица — акционера или эмитента,";
      }
      return "Уважаемый представитель,";
    },
    visitDate() {
      return this.forms.record
        ? dateToHuman(this.forms.record.data.visit_date)
        : "";
    },
    visitTime() {
      return this.forms.record ? this.forms.record.data.visit_time : "";
    },
    address() {
      return this.forms.record && this.forms.record.data.filial
        ? this.forms.record.data.filial.address
        : "";
    },
    mapLink() {
      if (!this.forms.record || !this.forms.record.data.filial) {
        return "";
      }

      return mapLink(this.forms.record.data.filial.coordinates);
    }
  },
  methods: {
    ...mapMutations("form", ["toggleSkip"]),
    ...mapActions("stages", ["setCurrent", "setCompleted", "setStages"]),
    toMain() {
      window.location.href = "/";
    }
  },
  created() {
    import("@/forms/data/stages").then(({ representative }) => {
      this.setStages(representative);
      this.setCompleted("record");
      this.setCompleted("representative-success");
      this.setCurrent("success");
    });
  }
};
</script>

<style lang="scss" scoped>
a {
  color: #3b7bbe;
  outline: 0;
  text-decoration: none;

  &:hover {
    color: #3b7bbe;
  }
}
.skip {
  &-header {
    img {
      margin: 0 auto;
      padding-bottom: 15px;
    }
    h1 {
      color: #fff;
      text-align: center;
      padding-bottom: 30px;
    }
  }

  .box {
    display: block;
    min-height: auto;

    p {
      font-size: 22px;
      line-height: 33px;
      color: #333;
      text-align: center;

      &.bold {
        font-weight: 700;
      }
    }

    .form__button {
      padding-top: 30px;

      button {
        margin: 0 auto;
      }
    }
  }
}
</style>
